module.exports = __webpack_public_path__ + "assets/img/privacy.ad825341.svg";